var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "online-preview" }, [
    _vm._m(0),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "online-preview-content",
        attrs: { "element-loading-text": "Loading..." },
      },
      [
        !_vm.loading
          ? [
              _vm.status === 200 && _vm.src
                ? _c("iframe", {
                    attrs: {
                      src: _vm.src,
                      width: "100%",
                      height: "100%",
                      frameborder: "0",
                    },
                  })
                : _vm.status === 404
                ? _c("el-result", {
                    attrs: {
                      icon: "warning",
                      title: "404",
                      subTitle: "Sorry, the file you requested does not exist.",
                    },
                  })
                : _vm.status === 500
                ? _c("el-result", {
                    attrs: {
                      icon: "error",
                      title: "404",
                      subTitle:
                        "Internal Server Error, please contact the administrator.",
                    },
                  })
                : _vm._e(),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "online-preview-header" }, [
      _c("h1", [_vm._v(" Online Preview ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }